// Generated by CoffeeScript 1.12.7
var Container, addParent, cc, findModule, findPath, getConfPaths, getPath, populateDi;

Container = require('./container');

findModule = require('./find-module').instance;

findPath = require('./find-module').path;

populateDi = require('./populate-di')(findModule);

addParent = require('./add-parent')(findModule, populateDi);

getConfPaths = require('./get-conf-paths')(findPath, findModule);

cc = require('./clear-cache');

getPath = function(o) {
  return o.path;
};

module.exports = function(opts) {
  var annotations, baseDir, clearCache, config, di, ref;
  config = opts.config, baseDir = opts.baseDir, annotations = opts.annotations, clearCache = opts.clearCache;
  if (clearCache) {
    cc(getConfPaths(baseDir, config).map(getPath));
  }
  di = new Container(annotations);
  if ((ref = config.parents) != null) {
    ref.forEach(function(p) {
      return addParent(di, baseDir, p, []);
    });
  }
  return populateDi(di, baseDir, config.modules, []);
};
